export default __webpack_public_path__ + "static/media/flexible.faf8b219.png";